import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const cardPadding = '20px';

const CardContainer = styled.div`
  perspective: 1000px;
  display: inline-block;
  position: relative;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  margin: 1rem;
`;

const SizerContainer = styled.div`
  display: grid;
  visibility: hidden;
  & > * {
    grid-area: 1/1;
  }
`;

const HiddenSizer = styled.div`
  padding: ${cardPadding};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  visibility: hidden;
`;

const CardInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: ${({ flipped }) => (flipped ? 'rotateY(180deg)' : 'none')};
  cursor: pointer;
  box-sizing: border-box;
`;

const CardFace = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 12px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  overflow: auto; /* Allow content to scroll if needed */
`;

const CardFront = styled(CardFace)`
  padding: ${cardPadding};
`;

const CardBack = styled(CardFace)`
  transform: rotateY(180deg);
  background: #f9f9f9;
  padding: ${cardPadding};
`;

export class FlippableCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flipped: false,
    };
  }

  toggleFlip = () => {
    this.setState((prevState) => ({ flipped: !prevState.flipped }));
  };

  render() {
    const { frontContent, backContent, maxWidth } = this.props;
    const { flipped } = this.state;

    return (
      <CardContainer onClick={this.toggleFlip} maxWidth={maxWidth}>
        <SizerContainer>
          <HiddenSizer>{frontContent}</HiddenSizer>
          <HiddenSizer>{backContent}</HiddenSizer>
        </SizerContainer>

        <CardInner flipped={flipped}>
          <CardFront>{frontContent}</CardFront>
          <CardBack>{backContent}</CardBack>
        </CardInner>
      </CardContainer>
    );
  }
}

FlippableCard.propTypes = {
  frontContent: PropTypes.node.isRequired,
  backContent: PropTypes.node.isRequired,
  maxWidth: PropTypes.string,
};

FlippableCard.defaultProps = {
  maxWidth: '100%',
};
